import React, { ReactElement } from 'react';
import {
  Button, Td, Th, Tr,
} from 'idsk-react-components';
import LegislativnyMaterialCreateUpdate
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import LegMaterialCreateStepEnum
  from '../../../../model/legislativnyMaterial/LegMaterialCreateStepEnum';
import './checkDataTable.scss';
import FilledTableRelatedData3 from './FilledTableRelatedData3';
import { pouzivatelIsAdmin } from '../../../../function/permissions';
import { useUserContext } from '../../../../context/UserContext';

interface Props {
  legislativnyMaterial: LegislativnyMaterialCreateUpdate;
  onChangeStep: (nextStep: LegMaterialCreateStepEnum) => Promise<void>;
  isUpdate?: boolean;
}

const FilledTablePredkladatel4 = ({
  legislativnyMaterial,
  onChangeStep,
  isUpdate,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();

  return (
    <>
      <FilledTableRelatedData3
        legislativnyMaterial={legislativnyMaterial}
        onChangeStep={onChangeStep}
        isUpdate={isUpdate}
      />
      {legislativnyMaterial.typ?.kod !== 'AktEU' && (
        <>
          <Tr>
            <Th>Zodpovedná inštitúcia</Th>
            <Td>{legislativnyMaterial.zodpovednaInstitucia?.uplnyNazov}</Td>
            <Td>
              {pouzivatelIsAdmin(pouzivatel) && isUpdate && (
                <Button
                  size="small"
                  buttonStyle="link"
                  onClick={() => {
                    onChangeStep(LegMaterialCreateStepEnum.PREDKLADATEL_4);
                  }}
                >
                  Zmeniť
                </Button>
              )}
            </Td>
          </Tr>
          <Tr>
            <Th>Zodpovedný predkladateľ</Th>
            <Td>{legislativnyMaterial?.zodpovednyPredkladatel?.nazov}</Td>
            <Td>
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChangeStep(LegMaterialCreateStepEnum.PREDKLADATEL_4);
                }}
              >
                Zmeniť
              </Button>
            </Td>
          </Tr>
          <Tr>
            <Th>Ďalší predkladatelia
              <span className="idsk-hint">
                (nepovinný údaj)
              </span>
            </Th>
            <Td>
              {legislativnyMaterial?.dalsiPredkladatelia
                ?.filter((dalsiPredkladatel) => dalsiPredkladatel?.predkladatel)
                ?.length > 1
                ? (
                  <ul>
                    {legislativnyMaterial.dalsiPredkladatelia.map(
                      (dalsiPredkladatel, index) => dalsiPredkladatel?.predkladatel && (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={index}>
                          {dalsiPredkladatel.predkladatel.nazov}
                        </li>
                      ),
                    )}
                  </ul>
                ) : legislativnyMaterial?.dalsiPredkladatelia[0]?.predkladatel?.nazov}
            </Td>
            <Td>
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChangeStep(LegMaterialCreateStepEnum.PREDKLADATEL_4);
                }}
              >
                Zmeniť
              </Button>
            </Td>
          </Tr>
        </>
      )}
    </>
  );
};

export default FilledTablePredkladatel4;
